export enum AIDateOperator {
    YESTERDAY,
    TODAY,
    TOMORROW,
    START_THIS_WEEK,
    END_THIS_WEEK,
    START_THIS_MONTH,
    END_THIS_MONTH,
    START_THIS_QUARTER,
    END_THIS_QUARTER,
    START_THIS_YEAR,
    END_THIS_YEAR,
    START_LAST_WEEK,
    END_LAST_WEEK,
    START_LAST_MONTH,
    END_LAST_MONTH,
    START_LAST_QUARTER,
    END_LAST_QUARTER,
    START_LAST_YEAR,
    END_LAST_YEAR,
    START_NEXT_WEEK,
    END_NEXT_WEEK,
    START_NEXT_MONTH,
    END_NEXT_MONTH,
    START_NEXT_QUARTER,
    END_NEXT_QUARTER,
    START_NEXT_YEAR,
    END_NEXT_YEAR
}
